const STATUS_MAP = {
  // Hoarding statuses
  Occupied: {
    dot: "bg-slate-400",
    badge: "bg-slate-50 text-slate-600 border-slate-100",
  },
  Available: {
    dot: "bg-emerald-500",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
  Blocked: {
    dot: "bg-rose-500",
    badge: "bg-rose-50 text-rose-700 border-rose-100",
  },
  Reserved: {
    dot: "bg-amber-500",
    badge: "bg-amber-50 text-amber-700 border-amber-100",
  },
  Maintenance: {
    dot: "bg-blue-500",
    badge: "bg-blue-50 text-blue-700 border-blue-100",
  },
  // Campaign statuses
  Active: {
    dot: "bg-emerald-500",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
  Paused: {
    dot: "bg-amber-400",
    badge: "bg-amber-50 text-amber-700 border-amber-100",
  },
  Completed: {
    dot: "bg-slate-400",
    badge: "bg-slate-50 text-slate-600 border-slate-100",
  },
  Draft: {
    dot: "bg-violet-400",
    badge: "bg-violet-50 text-violet-700 border-violet-100",
  },
  Cancelled: {
    dot: "bg-rose-500",
    badge: "bg-rose-50 text-rose-700 border-rose-100",
  },
  Pending: {
    dot: "bg-amber-500",
    badge: "bg-amber-50 text-amber-700 border-amber-100",
  },
  active: {
    dot: "bg-emerald-500",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
  inactive: {
    dot: "bg-slate-400",
    badge: "bg-slate-50 text-slate-600 border-slate-200",
  },
};

const DEFAULT_THEME = {
  dot: "bg-slate-400",
  badge: "bg-slate-50 text-slate-600 border-slate-200",
};

export function StatusBadge({ status, testId, size = "md" }) {
  const theme = STATUS_MAP[status] || DEFAULT_THEME;

  const sizeClasses = {
    sm: "px-2 py-0.5 text-[10px] gap-1",
    md: "px-2.5 py-1 text-[11px] gap-1.5",
    lg: "px-3 py-1.5 text-xs gap-2",
  }[size] || "px-2.5 py-1 text-[11px] gap-1.5";

  return (
    <span
      data-testid={testId}
      className={`
        inline-flex items-center font-semibold rounded-full border
        tracking-wide select-none
        ${theme.badge} ${sizeClasses}
      `}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full flex-shrink-0 ${theme.dot}`} />
      {status}
    </span>
  );
}
